import type { ReactNode } from "react";

import { useAppTheme } from "@hooks/useAppTheme";
import { DonutScore } from "@memorang/ui";

type Props = {
	percentage: number;
	color: string;
	radius: number;
	innerRadius: number;
	children: ReactNode;
};

export const ScoreDonut = ({
	percentage,
	color,
	radius,
	innerRadius,
	children,
}: Props) => {
	const theme = useAppTheme();
	return (
		<DonutScore
			distribution={[percentage, 100 - percentage]}
			score={percentage}
			variant="progress"
			radius={radius}
			innerRadius={innerRadius}
			customColorScale={[color, theme.colors.progress.none]}
			customChildren={children}
		/>
	);
};
